(function() {
  'use strict';

  const CONFIG = {
    maxWaitTime: 10000,
    checkInterval: 100,
    buttonSelector: 'button.gw-button-widget[gw-stock-fulfilled]',
    requiredAttributes: ['data-product-id', 'data-variant-id', 'data-product-handle']
  };

  let lastClickedButton = null;
  window.kbiteLastClickedButton = null;

  function waitForKbite() {
    return new Promise((resolve, reject) => {
      const startTime = Date.now();
      const checkKbite = setInterval(() => {
        if (window.growConfig && typeof window.growConfig.stockWidgetClicked === 'function') {
          clearInterval(checkKbite);
          resolve();
          return;
        }

        if (Date.now() - startTime > CONFIG.maxWaitTime) {
          clearInterval(checkKbite);
          console.error('❌ Kbite app failed to load within', CONFIG.maxWaitTime, 'ms');
          reject(new Error('Kbite timeout'));
          return;
        }
      }, CONFIG.checkInterval);
    });
  }

  function waitForAlpine() {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve();
      }, 500);
    });
  }

  function validateButton(button, index) {
    const validation = {
      valid: true,
      missing: [],
      data: {}
    };

    CONFIG.requiredAttributes.forEach(attr => {
      const value = button.getAttribute(attr);
      if (!value || value === 'undefined' || value === 'null') {
        validation.valid = false;
        validation.missing.push(attr);
      } else {
        validation.data[attr] = value;
      }
    });

    if (!validation.valid) {
      console.warn(`⚠️ Button ${index + 1} missing attributes:`, validation.missing, button);
    }

    return validation;
  }

  function injectFontsIntoModal(iframe) {
    return new Promise((resolve) => {
      let timeoutId;
      const checkIframeReady = setInterval(() => {
        try {
          const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;

          if (iframeDoc && iframeDoc.body) {
            clearInterval(checkIframeReady);
            clearTimeout(timeoutId);

            let fontBasePath = '/assets/';
            try {
              const existingLink = document.querySelector('link[href*="PPAgrandir"]');
              if (existingLink && existingLink.href) {
                fontBasePath = existingLink.href.substring(0, existingLink.href.lastIndexOf('/') + 1);
              } else {
                const themeLink = document.querySelector('link[href*="theme.css"]');
                if (themeLink && themeLink.href) {
                  fontBasePath = themeLink.href.substring(0, themeLink.href.lastIndexOf('/') + 1);
                }
              }
            } catch (e) {
              console.warn('⚠️ Could not detect asset path, using fallback:', fontBasePath);
            }

            const fontStyles = `
              @font-face {
                font-family: 'PP Agrandir';
                src: url('${fontBasePath}PPAgrandir-Regular.woff2') format('woff2'),
                     url('${fontBasePath}PPAgrandir-Regular.woff') format('woff');
                font-weight: 400;
                font-style: normal;
                font-display: swap;
              }

              @font-face {
                font-family: 'PP Agrandir';
                src: url('${fontBasePath}PPAgrandir-Bold.woff2') format('woff2'),
                     url('${fontBasePath}PPAgrandir-Bold.woff') format('woff');
                font-weight: 700;
                font-style: normal;
                font-display: swap;
              }

              @font-face {
                font-family: 'PP Agrandir';
                src: url('${fontBasePath}PPAgrandir-GrandHeavy.woff') format('woff');
                font-weight: 800;
                font-style: normal;
                font-display: swap;
              }

              @font-face {
                font-family: 'PP Agrandir';
                src: url('${fontBasePath}PPAgrandir-GrandLight.woff') format('woff');
                font-weight: 300;
                font-style: normal;
                font-display: swap;
              }

              .modal-container * {
                font-family: 'PP Agrandir', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif !important;
              }

              .modal-title {
                font-family: 'PP Agrandir', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif !important;
                font-weight: 700 !important;
              }

              .notification-message {
                font-family: 'PP Agrandir', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif !important;
              }

              .email-input,
              .notify-button,
              .privacy-text,
              .channel-selector button {
                font-family: 'PP Agrandir', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif !important;
              }

              .notify-button{
                border-radius: 12px;
              }

              .notify-button:hover{
                background: white;
                border-color: #c01f25;
                color: #c01f25;
              }
            `;

            const styleElement = iframeDoc.createElement('style');
            styleElement.textContent = fontStyles;
            iframeDoc.head.appendChild(styleElement);

            setTimeout(() => {
              try {
                const modalTitle = iframeDoc.querySelector('.modal-title');
                if (modalTitle) {
                  const computedStyle = iframeDoc.defaultView.getComputedStyle(modalTitle);
                  const fontFamily = computedStyle.fontFamily;

                  if (!fontFamily.includes('PP Agrandir')) {
                    console.warn('⚠️ Font may not be loading. Check font file URLs in Network tab.');
                  }
                }
              } catch (e) {
                console.warn('⚠️ Could not verify font application:', e.message);
              }
            }, 500);

            resolve(true);
          }
        } catch (error) {
          console.error('❌ Error injecting fonts:', error);
          clearInterval(checkIframeReady);
          resolve(false);
        }
      }, 50);

      timeoutId = setTimeout(() => {
        clearInterval(checkIframeReady);
        console.warn('⚠️ Timeout waiting for iframe to load');
        resolve(false);
      }, 5000);
    });
  }

  function ensureModal() {
    const modalId = 'gw-stock-fulfilled-iframe';
    let modal = document.getElementById(modalId);

    if (modal) {
      injectFontsIntoModal(modal);
      return true;
    }

    try {
      if (!window.initVar || !window.initVar.stockWidget || !window.initVar.stockWidget.modalHtml) {
        console.error('❌ Cannot create modal: initVar.stockWidget.modalHtml not found');
        return false;
      }

      const iframe = document.createElement('iframe');
      iframe.id = modalId;
      iframe.className = 'gw-modal';
      iframe.style.cssText = 'display: none; position: fixed; height: 100%; width: 100%; top: 0; z-index: 99999; overflow: hidden; border: none;';
      iframe.srcdoc = window.initVar.stockWidget.modalHtml;

      document.body.appendChild(iframe);

      injectFontsIntoModal(iframe);

      return true;
    } catch (error) {
      console.error('❌ Error creating modal iframe:', error);
      return false;
    }
  }

  function attachClickHandler(button, index) {
    try {
      const validation = validateButton(button, index);
      if (!validation.valid) {
        console.error(`❌ Skipping button ${index + 1}: validation failed`);
        return false;
      }

      if (button.dataset.kbiteInitialized === 'true') {
        return false;
      }

      button.addEventListener('click', function(event) {
        try {
          lastClickedButton = button;
          window.kbiteLastClickedButton = button;

          event.preventDefault();
          event.stopPropagation();

          const productId = button.getAttribute('data-product-id');
          const variantId = button.getAttribute('data-variant-id');
          const productHandle = button.getAttribute('data-product-handle');

          if (!productId || !variantId || !productHandle) {
            console.error('❌ Missing required data attributes at click time:', {
              productId,
              variantId,
              productHandle
            });
            alert('Error: Product information missing. Please refresh and try again.');
            return;
          }

          if (window.growConfig && typeof window.growConfig.stockWidgetClicked === 'function') {
            window.growConfig.stockWidgetClicked(event);
          } else {
            console.error('❌ Kbite stockWidgetClicked function not available');
            alert('Error: Notification service not available. Please refresh the page.');
          }
        } catch (error) {
          console.error('❌ Error in click handler:', error);
          alert('An error occurred. Please try again.');
        }
      });

      button.dataset.kbiteInitialized = 'true';
      return true;
    } catch (error) {
      console.error(`❌ Error attaching handler to button ${index + 1}:`, error);
      return false;
    }
  }

  function setupButtonUpdateOverride() {
    if (!window.initVar || !window.initVar.campaignPopUpNotifyButtonClicked) {
      console.warn('⚠️ Kbite initVar not found, cannot override button update');
      return false;
    }

    const originalNotifyButtonClicked = window.initVar.campaignPopUpNotifyButtonClicked;

    window.initVar.campaignPopUpNotifyButtonClicked = async function(id, workFlowId, inptData, optInToMarketing) {
      try {
        await originalNotifyButtonClicked.call(this, id, workFlowId, inptData, optInToMarketing);
      } catch (error) {
        console.error('❌ Error in original Kbite function:', error);
      }

      if (lastClickedButton || window.kbiteLastClickedButton) {
        const buttonToUpdate = lastClickedButton || window.kbiteLastClickedButton;

        try {
          const successText = window.initVar.stockWidget?.subscribedText ||
                             'We will notify you when the item is available';

          buttonToUpdate.innerText = successText;

          buttonToUpdate.style.backgroundColor = '#28a745';
          buttonToUpdate.style.borderColor = '#28a745';
          buttonToUpdate.style.cursor = 'default';

          buttonToUpdate.disabled = true;
          buttonToUpdate.setAttribute('data-submitted', 'true');

          setTimeout(() => {
            lastClickedButton = null;
            window.kbiteLastClickedButton = null;
          }, 1000);

        } catch (error) {
          console.error('❌ Error updating button:', error);
        }
      } else {
        console.warn('⚠️ No button reference found to update');
      }
    };

    return true;
  }

  function setupModalCloseHandler() {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
          const modal = document.getElementById('gw-stock-fulfilled-iframe');
          if (modal && modal.style.display === 'none') {
            if (lastClickedButton || window.kbiteLastClickedButton) {
              lastClickedButton = null;
              window.kbiteLastClickedButton = null;
            }
          }
        }
      });
    });

    let timeoutId;
    const checkModal = setInterval(() => {
      const modal = document.getElementById('gw-stock-fulfilled-iframe');
      if (modal) {
        clearInterval(checkModal);
        clearTimeout(timeoutId);
        observer.observe(modal, {
          attributes: true,
          attributeFilter: ['style']
        });
      }
    }, 500);

    timeoutId = setTimeout(() => clearInterval(checkModal), 10000);
  }

  function initializeButtons() {
    const buttons = document.querySelectorAll(CONFIG.buttonSelector);

    if (buttons.length === 0) {
      console.warn('⚠️ No Notify Me buttons found on this page');
      return;
    }

    const modalReady = ensureModal();
    if (!modalReady) {
      console.error('❌ Cannot initialize buttons: modal creation failed');
      return;
    }

    let attachedCount = 0;
    buttons.forEach((button, index) => {
      const success = attachClickHandler(button, index);
      if (success) {
        attachedCount++;
      }
    });

    if (attachedCount === 0) {
      console.warn('⚠️ Kbite Collection Initializer: No handlers attached');
    }
  }

  function observeDynamicContent() {
    const observer = new MutationObserver((mutations) => {
      const hasNewButtons = mutations.some(mutation => {
        return Array.from(mutation.addedNodes).some(node => {
          if (node.nodeType === 1) {
            return node.matches && node.matches(CONFIG.buttonSelector) ||
                   node.querySelector && node.querySelector(CONFIG.buttonSelector);
          }
          return false;
        });
      });

      if (hasNewButtons) {
        initializeButtons();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  async function init() {
    try {
      await waitForKbite();
      await waitForAlpine();
      setupButtonUpdateOverride();
      setupModalCloseHandler();
      initializeButtons();
      observeDynamicContent();
    } catch (error) {
      console.error('\n❌ Kbite Collection Initializer: FAILED');
      console.error('Error:', error);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
